/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A tenant-configured hint card for the oral exam waiting lounge.
 */
export interface OralExamLoungeHintResponse {
  title: string;
  body: string;
}
